import React from 'react';
import Select from 'react-select';

function getSelectedValue(options) {
  if (!options) return null;
  return Array.isArray(options) ? options.map(({ value }) => value) : options.value;
}

const FilterDropdown = ({
  options_list: optionList,
  onChange,
  filter,
  multiple,
  placeholder,
  noOptionsMessage,
  closeMenuOnSelect,
}) => {
  const value = filter ? filter.value : '';
  let selectedValue = optionList.filter(option => {
    return value && Array.isArray(value)
      ? value.includes(option.value)
      : option.value === value;
  });

  if (selectedValue && !multiple) selectedValue = selectedValue[0];

  return (
    <Select
      value={selectedValue}
      onChange={selected => onChange(getSelectedValue(selected))}
      isMulti={multiple}
      options={optionList}
      placeholder={placeholder}
      noOptionsMessage={noOptionsMessage}
      closeMenuOnSelect={closeMenuOnSelect}
      styles={{ menuPortal: base => ({ ...base, zIndex: 1 }) }}
    />
  );
};

export default FilterDropdown;
